import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PropertiesSettings } from "../../../../core/configuration/properties-settings";
import { Controparte } from '../../../models/controparte';

@Component({
    selector: '[add_doc_to_controparte]',
  templateUrl: 'add-to-controparte.component.html',
})

export class AddDocumentoToControparteComponent {
  readonly PROPERTIES_SETTINGS = PropertiesSettings;
  @Input()
  entity: Controparte;
  @Output()
  onClickAddToEntity = new EventEmitter();

  emitEntity(controparte: Controparte) {
    this.onClickAddToEntity.emit(controparte);
  }
}
